
import { User, CreditCard, BookOpen, SlidersHorizontal, Shield } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";

const sections = [
  {
    label: "Profile",
    icon: User,
    value: "profile",
  },
  {
    label: "Subscription",
    icon: CreditCard,
    value: "subscription",
  },
  {
    label: "My Content",
    icon: BookOpen,
    value: "content",
  },
  {
    label: "Notifications",
    icon: SlidersHorizontal,
    value: "notifications",
  },
];

export const AccountSidebar = ({
  selected,
  onSelect,
}: {
  selected: string;
  onSelect: (value: string) => void;
}) => {
  const { user } = useAuth();
  const isAdmin = user?.email === "larsheimsath@hotmail.com";
  
  return (
    <aside className="w-full md:w-64 border-r bg-white h-full flex flex-col justify-between">
      <nav className="flex flex-col gap-2 p-4">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <button
              type="button"
              key={section.value}
              className={cn(
                "flex items-center px-4 py-3 rounded-md text-left hover:bg-muted transition text-base",
                selected === section.value
                  ? "bg-muted text-ai-indigo font-semibold"
                  : "text-gray-700"
              )}
              onClick={() => onSelect(section.value)}
            >
              <Icon className="mr-3 w-5 h-5" />
              <span>{section.label}</span>
            </button>
          );
        })}
        
        {/* Only show admin section for specific user */}
        {isAdmin && (
          <button
            type="button"
            className={cn(
              "flex items-center px-4 py-3 w-full rounded-md text-left hover:bg-muted transition text-base",
              selected === "admin"
                ? "bg-muted text-ai-indigo font-semibold"
                : "text-gray-700"
            )}
            onClick={() => onSelect("admin")}
          >
            <Shield className="mr-3 w-5 h-5" />
            <span>Admin</span>
          </button>
        )}
      </nav>
    </aside>
  );
};
